// ============================================================================
// LEGAL LAYOUT — shared shell for the public policy pages.
// These pages render OUTSIDE AuthGate, so they must not touch AuthContext,
// CRMContext or the API — Razorpay's reviewer opens them without logging in.
// ============================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import companyInfo from './companyInfo';
import './Legal.css';

const NAV = [
  { to: '/pricing', label: 'Pricing' },
  { to: '/terms', label: 'Terms' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/refund', label: 'Refunds' },
  { to: '/contact', label: 'Contact' },
];

const LegalLayout = ({ title, subtitle, showEffectiveDate = true, children }) => (
  <div className="legal">
    <header className="legal__topbar">
      <Link to="/" className="legal__brand">
        <img src={`${process.env.PUBLIC_URL}/favicon-dark.ico`} alt="" className="legal__brand-mark" />
        <span>{companyInfo.brandName}</span>
      </Link>
      <nav className="legal__nav">
        {NAV.map((item) => (
          <Link key={item.to} to={item.to} className="legal__nav-link">{item.label}</Link>
        ))}
      </nav>
    </header>

    <main className="legal__main">
      <div className="legal__head">
        <h1>{title}</h1>
        {subtitle && <p className="legal__subtitle">{subtitle}</p>}
        {showEffectiveDate && (
          <p className="legal__meta">Effective from {companyInfo.effectiveDate}</p>
        )}
      </div>

      <div className="legal__body">{children}</div>
    </main>

    <footer className="legal__footer">
      <div className="legal__footer-links">
        {NAV.map((item) => (
          <Link key={item.to} to={item.to}>{item.label}</Link>
        ))}
      </div>
      <p className="legal__footer-legal">
        {companyInfo.legalName} · GSTIN {companyInfo.gstin}
      </p>
      <p className="legal__footer-legal">
        © {new Date().getFullYear()} {companyInfo.legalName}. All rights reserved.
      </p>
    </footer>
  </div>
);

export default LegalLayout;
